<account-verify       
                [userTitle]="strings.AccountRecovery"
                [userDescription]="strings.VerificationCodeRequestRecoverDescription"
                isNew="false"
                [userInputTitle]="strings.EmailOrUsername"
                [errorMessage]="message"
                (userSubmit)="onUserSubmit($event)"
                (codeSubmit)="onCodeSubmit($event)"></account-verify>